import type { CountryCode, Currency } from '@zep/types';

export const getZemChargeCurrency = (countryCode: CountryCode): Currency => {
  if (countryCode === 'KR') {
    return 'KRW';
  }

  if (countryCode === 'JP') {
    return 'JPY';
  }

  return 'USD';
};
